'use client';

import { ProgressProvider } from '@bprogress/next/app';
import React, { PropsWithChildren } from 'react';

import { AuthProvider } from '@/providers/auth-provider/auth-provider';
import NotificationBannerProvider from '@/providers/notification-banner-provider';
import { ReleaseNotesProvider } from '@/providers/release-notes-provider';
import RollbarProvider from '@/providers/rollbar-provider';
import StoreProvider from '@/providers/store-provider';
import ThemeProvider from '@/providers/theme-provider';
import { StoreInterface } from '@/stores/store';
import { User } from '@/typings/user';

type Props = {
  initialStoreData?: Partial<Omit<StoreInterface, 'updateData'>>;
  user?: User;
};

const Providers: React.FC<PropsWithChildren<Props>> = ({
  children,
  initialStoreData = {},
  user,
}) => {
  return (
    <RollbarProvider>
      <ProgressProvider
        height="3px"
        color="#290066"
        options={{ showSpinner: false }}
        shallowRouting
      >
        <StoreProvider initialData={{ ...initialStoreData }}>
          <AuthProvider initialUser={user}>
            <ThemeProvider>
              <NotificationBannerProvider>
                <ReleaseNotesProvider>{children}</ReleaseNotesProvider>
              </NotificationBannerProvider>
            </ThemeProvider>
          </AuthProvider>
        </StoreProvider>
      </ProgressProvider>
    </RollbarProvider>
  );
};

export default Providers;
